function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createSelector } from 'reselect';
import { Utils } from 'manifesto.js/dist-esmodule/Utils';
import flatten from 'lodash/flatten';
import CanvasGroupings from '../../lib/CanvasGroupings';
import MiradorCanvas from '../../lib/MiradorCanvas';
import { miradorSlice } from './utils';
import { getWindow } from './getters';
import { getSequence } from './sequences';
import { getWindowViewType } from './windows';
/** */

export var selectInfoResponses = function selectInfoResponses(state) {
  return miradorSlice(state).infoResponses;
};
export var getCanvases = createSelector([getSequence], function (sequence) {
  return sequence && sequence.getCanvases() || [];
});
/**
* Return the canvas selected by an id
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Object}
*/

export var getCanvas = createSelector([getSequence, function (state, _ref) {
  var canvasId = _ref.canvasId;
  return canvasId;
}], function (sequence, canvasId) {
  if (!sequence || !canvasId) return undefined;
  return sequence.getCanvasById(canvasId);
});
export var getCurrentCanvas = createSelector([getSequence, getWindow], function (sequence, window) {
  if (!sequence || !window) return undefined;
  if (!window.canvasId) return sequence.getCanvasByIndex(0);
  return sequence.getCanvasById(window.canvasId);
});
/** */

export var getVisibleCanvasIds = createSelector([getWindow], function (window) {
  return window && (window.visibleCanvases || window.canvasId && [window.canvasId]) || [];
});
/** */

export var getVisibleCanvases = createSelector([getVisibleCanvasIds, getCanvases], function (canvasIds, canvases) {
  return (canvases || []).filter(function (c) {
    return canvasIds.includes(c.id);
  });
});
/**
* Return the current canvases grouped by how they'll appear in the viewer
* For book view returns groups of 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

var getCanvasGroupings = createSelector([getCanvases, getWindowViewType], function (canvases, view) {
  return canvases && new CanvasGroupings(canvases, view).groupings();
});
/**
* Return the current canvases selected in a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getCanvasGrouping = createSelector([getCanvasGroupings, function (state, _ref2) {
  var canvasId = _ref2.canvasId;
  return canvasId;
}], function (groupings, canvasId) {
  return groupings && groupings.find(function (group) {
    return group.some(function (c) {
      return c.id === canvasId;
    });
  }) || [];
});
/**
* Return the next canvas(es) for a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getNextCanvasGrouping = createSelector([getCanvasGroupings, getCurrentCanvas], function (groupings, canvas, view) {
  if (!groupings || !canvas) return undefined;
  var currentGroupIndex = groupings.findIndex(function (group) {
    return group.some(function (c) {
      return c.id === canvas.id;
    });
  });
  if (currentGroupIndex < 0 || currentGroupIndex + 1 >= groupings.length) return undefined;
  var newGroup = groupings[currentGroupIndex + 1];
  return newGroup;
});
/**
* Return the previous canvas(es) for a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getPreviousCanvasGrouping = createSelector([getCanvasGroupings, getCurrentCanvas], function (groupings, canvas, view) {
  if (!groupings || !canvas) return undefined;
  var currentGroupIndex = groupings.findIndex(function (group) {
    return group.some(function (c) {
      return c.id === canvas.id;
    });
  });
  if (currentGroupIndex < 1) return undefined;
  var newGroup = groupings[currentGroupIndex - 1];
  return newGroup;
});
/**
* Return canvas label, or alternatively return the given index + 1 to be displayed
* @param {object} canvas
* @return {String|Integer}
*/

export var getCanvasLabel = createSelector([getCanvas], function (canvas) {
  return canvas && (canvas.getLabel().length > 0 ? canvas.getLabel().map(function (label) {
    return label.value;
  })[0] : String(canvas.index + 1));
});
/**
* Return canvas description
* @param {object} canvas
* @param {String}
*/

export var getCanvasDescription = createSelector([getCanvas], function (canvas) {
  return canvas && canvas.getProperty('description');
});
export var getVisibleCanvasNonTiledResources = createSelector([getVisibleCanvases], function (canvases) {
  return flatten(canvases.map(function (canvas) {
    return new MiradorCanvas(canvas).imageResources;
  })).filter(function (resource) {
    return resource.getServices().length < 1;
  });
});
export var selectInfoResponse = createSelector([function (state, _ref3) {
  var infoId = _ref3.infoId;
  return infoId;
}, getCanvas, selectInfoResponses], function (infoId, canvas, infoResponses) {
  var iiifServiceId = infoId;

  if (!infoId) {
    if (!canvas) return undefined;
    var miradorCanvas = new MiradorCanvas(canvas);
    var image = miradorCanvas.iiifImageResources[0];
    iiifServiceId = image && image.getServices()[0].id;
  }

  return iiifServiceId && infoResponses[iiifServiceId] && !infoResponses[iiifServiceId].isFetching && infoResponses[iiifServiceId];
});
var authServiceProfiles = {
  clickthrough: true,
  external: true,
  kiosk: true,
  login: true
};
/**
 *
 */

export function selectNextAuthService(_ref4, resource) {
  var auth = _ref4.auth;
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : authServiceProfiles;
  var orderedAuthServiceProfiles = ['http://iiif.io/api/auth/1/external', 'http://iiif.io/api/auth/1/kiosk', 'http://iiif.io/api/auth/1/clickthrough', 'http://iiif.io/api/auth/1/login'];
  var mapFilterToProfiles = {
    'http://iiif.io/api/auth/1/clickthrough': 'clickthrough',
    'http://iiif.io/api/auth/1/external': 'external',
    'http://iiif.io/api/auth/1/kiosk': 'kiosk',
    'http://iiif.io/api/auth/1/login': 'login'
  };

  for (var _i = 0, _orderedAuthServicePr = orderedAuthServiceProfiles; _i < _orderedAuthServicePr.length; _i++) {
    var profile = _orderedAuthServicePr[_i];
    var services = getServices(resource, profile);

    var _iterator = _createForOfIteratorHelper(services),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var service = _step.value;

        if (!auth[service.id]) {
          return filter[mapFilterToProfiles[profile]] && service;
        }

        if (auth[service.id].isFetching || auth[service.id].ok) return null;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return null;
}
/** */

export function selectActiveAuthService(state, resource) {
  var orderedAuthServiceProfiles = ['http://iiif.io/api/auth/1/login', 'http://iiif.io/api/auth/1/clickthrough', 'http://iiif.io/api/auth/1/kiosk', 'http://iiif.io/api/auth/1/external'];

  for (var _i2 = 0, _orderedAuthServicePr2 = orderedAuthServiceProfiles; _i2 < _orderedAuthServicePr2.length; _i2++) {
    var profile = _orderedAuthServicePr2[_i2];
    var services = getServices(resource, profile);
    var service = services.find(function (s) {
      return selectAuthStatus(state, s);
    });
    if (service) return service;
  }

  return null;
}
export var selectCanvasAuthService = createSelector([selectInfoResponse, function (state) {
  return state;
}], function (infoResponse, state) {
  var resource = infoResponse && infoResponse.json;
  if (!resource) return undefined;
  return selectNextAuthService(state, resource) || selectActiveAuthService(state, resource);
});
export var selectLogoutAuthService = createSelector([selectInfoResponse, function (state) {
  return state;
}], function (infoResponse, state) {
  if (!infoResponse) return undefined;
  var authService = selectActiveAuthService(state, infoResponse.json);
  if (!authService) return undefined;
  return authService.getService('http://iiif.io/api/auth/1/logout');
});
/** */

export function selectAuthStatus(_ref5, service) {
  var auth = _ref5.auth;
  if (!service) return null;
  if (!auth[service.id]) return null;
  if (auth[service.id].isFetching) return 'fetching';
  if (auth[service.id].ok) return 'ok';
  return 'failed';
}
/** Get all the services that match a profile */

function getServices(resource, profile) {
  var services = Utils.getServices(_objectSpread(_objectSpread({}, resource), {}, {
    options: {}
  }));
  return services.filter(function (service) {
    return service.getProfile() === profile;
  });
}